export const FILED_NAMES: Record<string, string> = {
  phone: 'phone number',
  ssn: 'social security number',
};
